import validateUpdateApplicationStatus from './validateUpdateApplicationStatus';

export default function validateUpdateAppointment(form) {
  return validateUpdateApplicationStatus(form);
}
